export enum PrefAndInformationPivotTabTypes {
  Upcoming = "Upcoming",
  Past = "Past"
}

export type AppointmentInformationModalInnerProps = {
  contactId: string;
  claimId: string | undefined;
  onDismissInfoModal: () => void;
};
